import { v4 as uuidv4 } from "uuid";
import { DEFAULT_ROWS } from "./Constants";
class LazyState {

    getMyReviewsLazyState() {
        var _lazyState = {
            first: 0,
            rows: 10,
            page: 1,
            sortField: "createdAt",
            sortOrder: -1,
            uuid: uuidv4()
        };
        return _lazyState;
    }

    getMyFriendsLazyState() {
        var _lazyState = {
            first: 0,
            rows: DEFAULT_ROWS,
            page: 1,
            sortField: "createdAt",
            sortOrder: -1,
            uuid: uuidv4()
        };
        return _lazyState;
    }

    getImportCompanyDataLazyState() {
        var _lazyState = {
            first: 0,
            rows: DEFAULT_ROWS,
            page: 1,
            sortField: "filedOnDate",
            sortOrder: -1,
            uuid: uuidv4()
        };
        return _lazyState;
    }

    resetLazyState(lazyState) {
        const _lazyState = {
            first: 0,
            rows: lazyState.rows,
            page: 1,
            sortField: lazyState.sortField,
            sortOrder: lazyState.sortOrder,
            uuid: uuidv4()
        };
        return _lazyState;
    }
}
export default new LazyState();